<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'orgManager' }">组织管理</el-breadcrumb-item>
            <el-breadcrumb-item>组织账户配置</el-breadcrumb-item>
        </el-breadcrumb>



        <!-- 表格分页-->
        <div class="block">

            <el-table :data="tableData" border style="width: 100%;" ref="table" @current-change="handleSelectionChange"
                      highlight-current-row
                      v-loading="loading2"
                      element-loading-text="拼命加载中...">
                <el-table-column type="index" width="55" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="role_id" label="id">  </el-table-column>
                <el-table-column prop="username" label="用户名" > </el-table-column>
                <el-table-column prop="name" label="当前权限" > </el-table-column>
                <el-table-column prop="time" label="更新时间"  :formatter="formatter"  sortable >  </el-table-column>
            </el-table>
        </div>

        <!--<div class="block">-->
            <!--<el-pagination-->
                    <!--@current-change="handleCurrentChange"-->
                    <!--@size-chahange="handleSizeChange"-->
                    <!--:current-page="currentpage"-->
                    <!--:page-count="pagesCount"-->
                    <!--:page-sizes="pagesizes"-->
                    <!--:page-size="pagesize"-->
                    <!--:total="pagesCount"-->
                    <!--layout=" total, prev, pager, next, jumper"-->
            <!--&gt;-->
            <!--</el-pagination>-->
        <!--</div>-->

        <el-row>
            <el-col :span="24" style="text-align: center;margin-top: 10px">
                <div class="grid-content bg-purple-dark">
                    <el-button type="success" @click="save" >保存</el-button>
                    <el-button @click="clearSelection">重置</el-button>
                </div>
            </el-col>
        </el-row>

    </div>
</template>
<!--<style>-->
<!--@import "../../../assets/css/button.css";-->
<!--</style>-->
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    export  default{
        data(){
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 80,//行数
                activeNum: 0, //默认起始行数
                endNum: 80,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                list:[],
                orgId:'',
                //参数设置
                url: this.requetHost+"/sys/user/findOrgUsers", // 分页查询请求路径
                topForm:{
                    rolename:''
                },
                loading2:false,
                userId :"",
                /*弹窗选择*/
                multipleSelection: [],
                btn_0427:true,
            }

        },
        created(){
            var params=this.$route.params.row;
            this.orgId=params.org_id;
            //调用查询函数

            this.getData();

        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求
                this.loading2 = true
                var params = {active:this.activeNum,len:this.endNum,storeId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {

                            this.pagesCount = response.body.total;
                            this.tableData = response.body.data;
                            //this.getconfig();
                            this.loading2 = false;
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            getconfig(){
                //异步请求
                this.$http.get(this.requetHost+"/sys/role/roleUserFind",{params:{"userId":this.userId}})
                    .then(response => {

                        if (response.status === 200) {
                            this.$refs.table.clearSelection();
                            this.list = response.body.list;
                            if(this.list != null && this.list != undefined && this.list.length!=0){
                                // var array=new Array();
                                this.tableData.forEach((row) => {
                                    this.list.forEach((item) => {
                                        if(item.role_id === row.role_id){
                                            this.$refs.table.toggleRowSelection(row, true);
                                        }

                                    })
                                });
                                //this.multipleSelection=

                            }
                        }
                        this.loading2 = false;
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatter(row, column) {
                var d = new Date(row.time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },

            save() {
                if(this.multipleSelection.user_id != "" && this.multipleSelection.user_id != undefined){
                    debugger
                    var params={orgId:this.orgId,userId:this.multipleSelection.user_id};
                    //异步请求
                    this.$http.post(this.requetHost+"/sys/userOrg/saveUserOrg",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.Code=='200'){
                                    this.$message({showClose: true,message: '保存成功',type: 'success'});
                                }else if(response.body.code=='500'){
                                    this.$message({showClose: true,message: '参数错误',type: 'error'});
                                }
                            }
                            this.loading2 = false;
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }else {
                    this.$message({showClose: true,message: '请选择账户绑定',type: 'error'});
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            handleSelectionChange(val) {
                this.$message({showClose: true,message: '已选中'+val.username,type: 'success'});
                this.multipleSelection = val;
                console.log(this.multipleSelection);
            },
            clearSelection() {
                this.$refs.table.clearSelection(this.multipleSelection);

                this.getData();

            },
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var flag=false;
                    if(data.length>0) {
                        for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                            if(btnId=="btn_0427"){//是否拥有0427权限
                                flag=true;
                            }
                        }
                    }
                    if(flag==false){
                        _this.btn_0427=false;
                    }
                })
            },
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'getData'
        }

    }

</script>
<style>

</style>


// WEBPACK FOOTER //
// OrgUser.vue?362e9974